import React, {useState} from "react"

import {ShopOutlined} from "@ant-design/icons"
import {message, Modal, Result} from "antd"
import {unbindShop} from "../../../api/clubPlatform"
import {useClubPlatformContext} from "../store/useClubPlatformContext"

const ClubPlatformUnbind = ({platformId}) => {
    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const {getRelationStore}=useClubPlatformContext()

    const handleClick = () => {
        setIsShow(true)
    }
    const handleOk = async () => {
        setIsLoading(true)
        await unbindShop(platformId).then(res => {
            if (res.status !== 1) {
                message.error(`解绑店铺失败：${res.detail}`)
                return
            }
            message.success("解绑店铺成功")
            setIsShow(false)
            getRelationStore()
        }).catch(err => {
            message.error(`解绑店铺失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)

        })
    }

    return (
        <div>
            <div onClick={handleClick}>
                <ShopOutlined/>
                <span style={{marginLeft: "5px"}}>解绑店铺</span>
            </div>
            <Modal
                open={isShow}
                onOk={handleOk}
                onCancel={() => {
                    setIsShow(false)
                }}
                confirmLoading={isLoading}
            >
                <Result title={"确定要解除当前绑定店铺吗"} status={"warning"}/>
            </Modal>
        </div>
    )
}

export default ClubPlatformUnbind



// WEBPACK FOOTER //
// ./src/containers/ClubPlatform/component/ClubPlatformUnbindShop.js